import React from 'react';
import PaymentMethod from './components/PaymentMethod';
import BillingHistory from './components/BillingHistory';
import Button from '../../components/ui/Button';
import { Plus } from 'lucide-react';

const Billing = () => {
  const paymentMethods = [
    {
      id: 1,
      last4: '4242',
      expMonth: '12',
      expYear: '24',
      isDefault: true
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-8">Billing & Payments</h1>
      
      <div className="space-y-8">
        <div className="bg-white rounded-xl shadow-sm p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold">Payment Methods</h2>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Add Payment Method
            </Button>
          </div>
          
          <div className="space-y-4">
            {paymentMethods.map(method => (
              <PaymentMethod
                key={method.id}
                card={method}
                isDefault={method.isDefault}
                onSetDefault={() => {}}
                onRemove={() => {}}
              />
            ))}
          </div>
        </div>
        
        <BillingHistory />
      </div>
    </div>
  );
};

export default Billing;